import React, { useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '');

/**
 * Hub IAM redirects here (registered OAUTH_REDIRECT_URI).
 * Forward code/state to the backend callback so PKCE session cookies are available.
 */
const HubCallback = () => {
  const forwarded = useRef(false);

  useEffect(() => {
    if (forwarded.current) return;
    forwarded.current = true;

    const params = new URLSearchParams(window.location.search);
    const target = `${API_BASE}/api/auth/callback?${params.toString()}`;
    window.location.replace(target);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography color="text.secondary">Completing sign-in…</Typography>
    </Box>
  );
};

export default HubCallback;
